var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 29.8337C8.63935 29.8337 2.66602 23.8737 2.66602 16.5003C2.66602 9.14033 8.63935 3.16699 15.9993 3.16699C23.3727 3.16699 29.3327 9.14033 29.3327 16.5003C29.3327 23.8737 23.3727 29.8337 15.9993 29.8337ZM20.2526 21.4472C20.4126 21.5406 20.5859 21.5939 20.7726 21.5939C21.1059 21.5939 21.4392 21.4206 21.6259 21.1006C21.9059 20.6339 21.7592 20.0206 21.2792 19.7272L16.5326 16.9006V10.7406C16.5326 10.1806 16.0792 9.74056 15.5326 9.74056C14.9859 9.74056 14.5326 10.1806 14.5326 10.7406V17.4739C14.5326 17.8206 14.7192 18.1406 15.0259 18.3272L20.2526 21.4472Z",
    fill: "#0799B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.122f8e591896921a579e948944d3fe43.svg";
export { ForwardRef as ReactComponent };